import logger from '../utils/logger.js';
import { isAuthenticated } from '../utils/auth.js';
import { getPagename } from '../utils/dataRouteFormat.js';
import { useRouter } from 'next/router';
import { useContext } from 'react';
import { CoreContext } from '../context/index.js';
import '../utils/logToSlack.js';
import '../utils/cookies.js';
import 'cookies-next';
import '../cookies-l-jEMp6P.js';
import '../currency-_kacFJHO.js';
import '../language-BHHwgtQp.js';
import '../payment-YC9H491Y.js';
import '../utils/isBot.js';

// Function: Pushes "User Click" event to dataLayer
// Specs:
// - This function is implemented to track user behavior on the page
const userInteraction = (eventName, options) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event_data: null });
    window.dataLayer.push({
        event: eventName,
        event_data: options,
    });
    logger('User Interaction event sent', { category: 'analytics' });
};

const useUserInteractionEvent = () => {
    const { route, asPath } = useRouter();
    const { data: { siteConfig: { catalogId, overrideDataLayerRoutes = [] }, }, } = useContext(CoreContext);
    const getOverrideRouteObj = () => {
        // Override route logic
        let overrideObj;
        overrideDataLayerRoutes.forEach(routeObj => {
            if (asPath.includes(routeObj.name)) {
                overrideObj = routeObj;
            }
        });
        return overrideObj;
    };
    const userClickHandler = (e) => {
        const target = e.target;
        const eventElement = target.closest('[data-event-name]');
        if (!eventElement) {
            return;
        }
        const eventName = eventElement === null || eventElement === void 0 ? void 0 : eventElement.dataset.eventName;
        const user_is_logged = isAuthenticated() ? 1 : 0;
        const menu_label = eventElement === null || eventElement === void 0 ? void 0 : eventElement.dataset.menuLabel;
        const bloc_name = eventElement === null || eventElement === void 0 ? void 0 : eventElement.dataset.blocName;
        const event_enroll_context = eventElement === null || eventElement === void 0 ? void 0 : eventElement.dataset.eventEnrollContext;
        const event_cta_name = eventElement === null || eventElement === void 0 ? void 0 : eventElement.dataset.eventCtaName;
        const event_label = eventElement === null || eventElement === void 0 ? void 0 : eventElement.dataset.eventLabel;
        const event_search_term = eventElement === null || eventElement === void 0 ? void 0 : eventElement.dataset.eventSearchTerm;
        const event_popin_name = eventElement === null || eventElement === void 0 ? void 0 : eventElement.dataset.eventPopinName;
        const event_popin_cta_name = eventElement === null || eventElement === void 0 ? void 0 : eventElement.dataset.eventPopinCtaName;
        const event_category = eventElement === null || eventElement === void 0 ? void 0 : eventElement.dataset.eventCategory;
        const event_action = eventElement === null || eventElement === void 0 ? void 0 : eventElement.dataset.eventAction;
        // const menu_position = eventElement?.dataset.menuPosition;
        const pagename = getPagename(route, catalogId, asPath, getOverrideRouteObj());
        const options = {
            pagename,
            user_is_logged,
        };
        if (event_action) {
            options.action = event_action;
        }
        if (event_category) {
            options.category = event_category;
        }
        if (event_label) {
            options.label = event_label;
        }
        if (menu_label) {
            options.menu_label = menu_label;
        }
        if (bloc_name) {
            options.bloc_name = bloc_name;
        }
        if (event_enroll_context) {
            options.enroll_context = event_enroll_context;
        }
        if (event_cta_name) {
            options.cta_name = event_cta_name;
        }
        if (event_search_term) {
            options.search_term = event_search_term;
        }
        if (event_popin_name) {
            options.popin_name = event_popin_name;
        }
        if (event_popin_cta_name) {
            options.popin_cta_name = event_popin_cta_name;
        }
        userInteraction(eventName, options);
    };
    const manualUserClickHandler = (eventName, options) => {
        const user_is_logged = isAuthenticated() ? 1 : 0;
        const pagename = getPagename(route, catalogId, asPath, getOverrideRouteObj());
        userInteraction(eventName, { ...options, user_is_logged, pagename });
    };
    return {
        userClickHandler,
        manualUserClickHandler,
    };
};

export { useUserInteractionEvent as default };
//# sourceMappingURL=useUserInteractionEvent.js.map
